import { h, ComponentChildren } from 'preact';

export interface StatsBarProps {
  count?: number;
  singular?: string;
  plural?: string;
  children?: ComponentChildren;
  actions?: ComponentChildren;
}

export function StatsBar({ count, singular, plural, children, actions }: StatsBarProps) {
  return (
    <div class="stats">
      <span>
        {children ?? (
          <>{count} {count === 1 ? singular : plural}</>
        )}
      </span>
      {actions}
    </div>
  );
}
